import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import styled from "styled-components"
import PostFeatured from "../components/postFeatured"
import PostLatest from "../components/postLatest"
import { HeadingTwo, SectionHeading } from "../elements"
import { breakpointMedium, breakpointLarge, textColorDark } from "../variables"
import PostFBFeed from "../components/postFbFeed"

const NewsAndUpdates = ({ data }) => {
  const posts = data.allPrismicPost.edges
  const { featured_post } = data.allPrismicNewsAndUpdates.edges[0].node.data
  const featuredPostInfo = posts.filter(
    post => post.node.slugs[0] === featured_post.slug
  )[0].node

  return (
    <Layout>
      <SEO title="News And Updates" />
      <HeadingTwo
        fontSize="32px"
        fontWeight="400"
        textAlign="center"
        padding="50px 0 0 0"
        color={textColorDark}
      >
        News & Updates{" "}
      </HeadingTwo>

      <ContentWrapper>
        <NewsContainer>
          <SectionHeading
            fontSize="15px"
            margin="0 0 10px 0"
            color={textColorDark}
          >
            FEATURED
          </SectionHeading>
          <PostFeatured post={featuredPostInfo} />

          <SectionHeading
            fontSize="15px"
            margin="0 0 18px 0"
            color={textColorDark}
          >
            LATEST NEWS
          </SectionHeading>
          {posts.map(
            (post, i) =>
              featuredPostInfo.slugs[0] !== post.node.slugs[0] && (
                <PostLatest
                  post={post.node}
                  key={i}
                  featuredPostInfo={featuredPostInfo}
                />
              )
          )}
        </NewsContainer>
        <PostFBFeed />
      </ContentWrapper>
    </Layout>
  )
}

export default NewsAndUpdates

export const ContentWrapper = styled.section`
  display: grid;
  padding: 50px 20px 144px 20px;
  margin: 0 auto;

  @media (min-width: ${breakpointMedium}) {
    grid-template-columns: 2.5fr 1fr;
    grid-gap: 60px;
    max-width: 1167px;
  }

  @media (min-width: ${breakpointLarge}) {
    max-width: 1450px;
    padding: 50px 0px 144px 0px;
  }
`

const NewsContainer = styled.div`
  min-height: 100vh;
`

// TODO Figure out how to incorporate the load more
export const query = graphql`
  {
    allPrismicNewsAndUpdates {
      edges {
        node {
          data {
            page_title {
              text
            }
            featured_post {
              slug
            }
          }
        }
      }
    }
    allPrismicPost(sort: { fields: data___release_date, order: DESC }) {
      edges {
        node {
          tags
          slugs
          first_publication_date
          data {
            title {
              text
            }
            release_date
            description {
              html
            }
            featured_image {
              url
              localFile {
                childImageSharp {
                  fluid(quality: 85) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            source {
              text
            }
          }
        }
      }
    }
  }
`
